import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { QuickStepsConfig } from '../store/schema/QuickStepsConfig';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { logUsage } from 'owa-analytics';
import { QuickStepsLoadState } from '../store/schema/QuickStepsLoadState';

export const initializeQuickStepsMutator: (
    mailboxInfo: MailboxInfo,
    quickStepsConfig: QuickStepsConfig,
    overwrite?: boolean
) => void = mutatorAction(
    'initializeQuickSteps',
    (mailboxInfo: MailboxInfo, quickStepsConfig: QuickStepsConfig, overwrite?: boolean): void => {
        const store = getStore();
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        if (!store.quickStepsStoreMap.has(accountKey) || overwrite) {
            store.quickStepsStoreMap.set(accountKey, {
                version: quickStepsConfig.version,
                quickSteps: quickStepsConfig.quickSteps,
                errorState: quickStepsConfig.errorState,
                runOnce: quickStepsConfig.runOnce,
            });

            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logUsage('QuickStepTotal', undefined, [quickStepsConfig.quickSteps.length]);
        }
        store.loadingStatesMap.set(
            accountKey,
            quickStepsConfig.errorState
                ? QuickStepsLoadState.ConfigError
                : QuickStepsLoadState.Loaded
        );
    }
);
